// Polyfills for iOS Safari compatibility

// URLSearchParams polyfill for older iOS versions
if (!window.URLSearchParams) {
  window.URLSearchParams = function(searchString) {
    const self = this;
    self.searchString = searchString;
    self.get = function(name) {
      const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(self.searchString);
      if (results == null) {
        return null;
      } else {
        return decodeURIComponent(results[1]) || '';
      }
    };
  };
}

// Promise polyfill
if (!window.Promise) {
  window.Promise = Promise;
}

// Object.assign polyfill
if (!Object.assign) {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    const to = Object(target);

    for (let index = 1; index < arguments.length; index++) {
      const nextSource = arguments[index];

      if (nextSource != null) {
        for (const nextKey in nextSource) {
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

// Array.from polyfill
if (!Array.from) {
  Array.from = function(object) {
    'use strict';
    return [].slice.call(object);
  };
}